<template>
  <div class="login-container g-flex-cc g-flex-ac g-flex">
    <div class="__main g-flex">
      <div class="__left">
        <img
          src="./img/yun1.png"
          class="yun"
        ><img
          src="./img/yun.png"
          class="yun1"
        >
        <div class="computer">
          <img
            src="./img/ele-1.png"
            alt=""
            class="ele-1"
          >
          <img
            src="./img/computer.png"
            alt=""
          >
          <img
            src="./img/ele-2.png"
            alt=""
            class="ele-2"
          >
          <img
            src="./img/Path.png"
            alt=""
            class="path"
          >
          <img
            src="./img/man1.png"
            alt=""
            class="person"
          >
          <img
            src="./img/arrow.png"
            alt=""
            class="arrow"
          >
          <img
            src="./img/arrow1.png"
            alt=""
            class="arrow1"
          >
        </div>
      </div>
      <div class="right">
        <img
          src="./img/logo.png"
          alt=""
        >
        <div class="__input">
          <div class="__input-container g-flex g-flex-ac">
            <i class="iconfont icon-people" />
            <input
              v-model="form.username"
              type="text"
              @keyup.enter.prevent="handleLogin"
            >
          </div>
          <div class="__line" />
        </div>
        <div class="__input">
          <div class="__input-container g-flex g-flex-ac">
            <i class="iconfont icon-lock" />
            <input
              v-model="form.password"
              type="password"
              @keyup.enter.prevent="handleLogin"
            >
          </div>
          <div class="__line" />
        </div>
        <div
          v-show="error"
          class="error-msg"
        >{{ error }}</div>
        <a
          href="javascript:;"
          @click="handleLogin"
        >登录</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'login',
    data() {
      return {
        form: {
          username: 'admin',
          password: '1qaz!QAZ'
        },
        error: ''
      };
    },
    mounted() {
      this.form.username = localStorage.getItem('username') || '';
      this.form.password = localStorage.getItem('password') || '';
    },
    methods: {
      handleLogin() {
        if (!this.form.username) {
          this.$message.error('请输入用户名');
          return;
        } if (!this.form.password) {
          this.$message.error('请输入密码');
          return;
        }
        this.$axios({
          url: '/user/login.htm',
          method: 'POST',
          data: {
            username: this.form.username,
            password: this.form.password,
          }
        }).then(res => {
          localStorage.setItem('menuList', JSON.stringify(res.data.menuNodeVo));
          localStorage.setItem('username', this.form.username);
          localStorage.setItem('password', this.form.password);
          localStorage.setItem('userToken', res.data.token);
          localStorage.setItem('userInfo', JSON.stringify(res.data.adminVo));
          let authsList = res.data.auths && res.data.auths.map(item => {
            let code = item.code + '';
            return code.replace(/\s/g, '');
          });
          let menusList = res.data.menus && res.data.menus.map(item => {
            let url = item.url + '';
            return url.replace(/\s/g, '');
          });
          localStorage.setItem('userAuths', JSON.stringify([...authsList, ...menusList]));
          this.$router.push('/');
        });
      }
    },
  };
</script>

<style scoped lang='scss'>
  .login-container {
    width: 100vw;
    height: 100vh;
    background: url("./img/bg.png") no-repeat;
    background-size: cover;
  }
  .__main {
    width: 1366px;
    .__left {
      position: relative;
      width: 770px;
      height: 768px;
      background: url("./img/bg-main.png") no-repeat;
      background-size: cover;
      img {
        display: block;
      }
      .ele-1 {
        position: absolute;
        top: 46px;
        left: 319px;
        animation: drumpDown 1s;
        animation-direction: alternate;
      }
      .path {
        position: absolute;
        top: 200px;
        left: 234px;
      }
      .person {
        position: absolute;
        top: 203px;
        left: 293px;
      }
      .yun {
        position: absolute;
        top: 98px;
        right: 180px;
      }
      .yun1 {
        position: absolute;
        top: 283px;
        right: 30px;
      }
      .arrow {
        position: absolute;
        top: 351px;
        right: 366px;
        animation: drump 1s;
        animation-direction: alternate;
      }
      .arrow1 {
        position: absolute;
        top: 400px;
        right: 320px;
        animation: drump 1s;
        animation-direction: alternate;
      }
      .computer {
        position: relative;
        width: 409px;
        height: 428px;
        position: absolute;
        top: 163px;
        left: 124px;
      }
      .ele-2 {
        position: absolute;
        top: 41px;
        left: 72px;
      }
    }
    .right {
      background: #fff;
      flex: 1;

      img {
        display: block;
        margin: 0 auto;
        margin-bottom: 157px;
        margin-top: 115px;
      }
      .__input {
        position: relative;
        width: 410px;
        margin: 0 auto;
        margin-bottom: 50px;
        .error-msg {
          bottom: -20px;
          position: absolute;
          text-align: right;
          color: #ff4642;
          font-size: 14px;
          margin-top: 20px;
        }
        i {
          font-size: 24px;
        }
        input {
          padding: 10px 10px;
          display: block;
          width: 100%;
          border: none;
          outline: none;
          color: rgba(51, 51, 51, 1);
          font-size: 16px;
        }
        .__line {
          width: 100%;
          height: 1px;
          background: rgba(216, 216, 216, 1);
        }
      }
      a {
        display: block;
        width: 410px;
        height: 56px;
        line-height: 56px;
        background: rgba(40, 156, 239, 1);
        border-radius: 28px;
        font-size: 16px;
        color: rgba(255, 255, 255, 1);
        text-decoration: none;
        text-align: center;
        margin: 102px auto 0 auto;
      }
    }
  }
  @media screen and (max-height: 800px) {
    .__main {
      transform: scale(0.7);
      input {
        font-size: 20px;
      }
    }
  }
  @keyframes drump {
    0% {
      transform: translateY(100px);
    }
    100% {
      transform: translateY(0);
    }
  }
  @keyframes drumpDown {
    0% {
      transform: translateY(-100px);
    }
    100% {
      transform: translateY(0);
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/login/index.vue